import React from 'react';
import PropTypes from 'prop-types';
import { AutoCompleteResultByContinentType } from 'app/models/AutocompleteResult';
import { retryCall } from 'app/api';
import { ErrorType } from 'app/models/Error';

const Dropdown = React.lazy(() => retryCall(() => import('app/components/ui/Dropdown')));


export const TripLocationPicker = ({
    direction,
    translationGetLabel,
    selected,
    onChangeLocation,
    groupLocationsBy,
    onRequestAutocomplete,
    onClearAutocomplete,
    onRequestDefaultAutocomplete,
    autocompleteResults,
    defaultResults,
    autocompleteLoading,
    error,
    onOpen,
    onClose,
}) => (
    <React.Fragment>
        <Dropdown
            direction={direction}
            title={translationGetLabel()}
            label={translationGetLabel()}
            selected={selected.name}
            onChange={onChangeLocation}
            onRequestAutocomplete={onRequestAutocomplete}
            onClearAutocomplete={onClearAutocomplete}
            onRequestDefaultAutocomplete={onRequestDefaultAutocomplete}
            defaultResults={defaultResults}
            autocompleteResults={autocompleteResults}
            autocompleteLoading={autocompleteLoading}
            autoScroll={Boolean(groupLocationsBy)}
            error={error}
            onOpen={onOpen}
            onClose={onClose}
        />
    </React.Fragment>
);

TripLocationPicker.propTypes = {
    direction: PropTypes.string.isRequired,
    translationGetLabel: PropTypes.func.isRequired,

    onChangeLocation: PropTypes.func.isRequired,
    onRequestAutocomplete: PropTypes.func.isRequired,
    onClearAutocomplete: PropTypes.func.isRequired,
    onRequestDefaultAutocomplete: PropTypes.func.isRequired,
    autocompleteResults: AutoCompleteResultByContinentType,
    defaultResults: AutoCompleteResultByContinentType,
    autocompleteLoading: PropTypes.bool.isRequired,
    groupLocationsBy: PropTypes.string,
    selected: PropTypes.shape({ name: PropTypes.string }),
    error: ErrorType.isRequired,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
};

TripLocationPicker.defaultProps = {
    groupLocationsBy: null,
    autocompleteResults: new Map(),
    defaultResults: new Map(),
    selected: { name: '' },
    onOpen: () => {
    },
    onClose: () => {
    },
};
